module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('keep-alive', [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52ec71f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./core-dms/projects/candao-dms-std/fgfRegister/index.vue
// module id = 905
// module chunks = 133